"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _momentRange = require("moment-range");

var _months = _interopRequireDefault(require("../constants/months"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var moment = (0, _momentRange.extendMoment)(_moment.default);
var _default = {
  uuidv4: function uuidv4() {
    /* return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    ); */
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  },
  Color: {
    getHue: function getHue(str) {
      var hash = 0;
      if (str.length === 0) return hash;

      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }

      return Math.abs(hash % 360);
    },
    getHSLPrimary: function getHSLPrimary(hue) {
      return "hsl(".concat(hue, ", 60%, 45%)");
    },
    getHSLSecondary: function getHSLSecondary(hue) {
      return "hsl(".concat(hue, ", 60%, 84%)");
    },
    getHSLTertiary: function getHSLTertiary(hue) {
      return "hsl(".concat(hue, ", 60%, 80%)");
    }
  },
  Percentage: {
    format: function format(value) {
      return new Intl.NumberFormat('nl-NL', {
        maximumSignificantDigits: 2
      }).format(value);
    },
    formatAfterChange: function formatAfterChange(v) {
      var value = v;

      if (isNaN(parseFloat(value, 10))) { // do nothing if it is not a float
        // probably contains alpha-numeric
      } else {
        if (value.indexOf(',') < 0) {
          value += ',00';
        }

        var split = value.split(',');

        if (split[1].length > 2) {
          split[1] = split[1].slice(0, 2);
        } else if (split[1].length === 1) {
          split[1] += '0';
        } else if (split[1].length === 0) {
          split[1] += '00';
        }

        while (split[0][0] === '0') {
          split[0] = split[0].replace('0', '');
        }

        value = split.join(',');
      }

      return value;
    },
    parse: function parse(value) {
      if (value == null) return value;
      value = value.toString().replace('.', ',');

      if (value.indexOf(',') < 0 && !isNaN(parseInt(value, 10))) {
        value += ',00';
      }

      return value;
    }
  },
  Currency: {
    formatCurrency: function formatCurrency(value) {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(value);
    }
  },
  Dates: {
    formatDate: function formatDate(value) {
      if (value && value.indexOf('-') > -1) {
        var splitDate = value.split('-'); // return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;

        return "".concat(this._leftPad(splitDate[2]), " ").concat(_months.default.months[parseInt(splitDate[1], 10) - 1], " ").concat(splitDate[0]);
      } else {
        return value;
      }
    },
    searchDates: function searchDates(value) {
      if (value && value.indexOf('-') > -1) {
        var result = '';
        var splitDate = value.split('-');
        result += "".concat(splitDate[2], "-").concat(splitDate[1], "-").concat(splitDate[0]);
        result += "".concat(this._leftPad(splitDate[2]), "-").concat(this._leftPad(splitDate[1]), "-").concat(splitDate[0]);
        result += "".concat(splitDate[2], " ").concat(_months.default.months[parseInt(splitDate[1], 10) - 1], " ").concat(splitDate[0]);
        result += "".concat(this._leftPad(splitDate[0]), "-").concat(this._leftPad(splitDate[1]), "-").concat(splitDate[2]);
        return result;
      } else {
        return value;
      }
    },
    _leftPad: function _leftPad(value) {
      if (value[0] === '0') {
        return value.replace('0', '');
      }

      return value;
    },
    isGreaterThan: function isGreaterThan(start, end) {
      return new Date(start) > new Date(end);
    },
    differenceFromNowInDays: function differenceFromNowInDays(thenDate) {
      // will return positive number for past, negative for future
      var now = moment().startOf('day');
      var then = moment(thenDate, 'YYYY-MM-DD');
      return moment.duration(now.diff(then)).asDays();
    },
    differenceFromNowInWeeks: function differenceFromNowInWeeks(thenDate) {
      var now = moment().startOf('day');
      var then = moment(thenDate, 'YYYY-MM-DD');
      return moment.duration(now.diff(then)).asWeeks();
    },
    differenceBetweenDatesInDays: function differenceBetweenDatesInDays(startDate, endDate) {
      var start = moment(startDate, 'YYYY-MM-DD');
      var end = moment(endDate, 'YYYY-MM-DD');
      return moment.duration(end.diff(start)).asDays();
    },
    datesRange: function datesRange(startDate, endDate) {
      var start = moment(startDate, 'YYYY-MM-DD');
      var end = moment().startOf('day');

      if (endDate != null) {
        end = moment(endDate, 'YYYY-MM-DD');
      }

      var range = moment().range(start, end);
      return Array.from(range.by('days')).map(function (m) {
        return m.format('YYYY-MM-DD');
      });
    },
    addDays: function addDays(startDate, nrOfDays) {
      return moment(startDate, 'YYYY-MM-DD').add(nrOfDays, 'days').format('YYYY-MM-DD');
    },
    addYears: function addYears(startDate, nrOfYears) {
      return moment(startDate, 'YYYY-MM-DD').add(nrOfYears, 'years').format('YYYY-MM-DD');
    },
    isWeekend: function isWeekend(date) {
      var day = new Date(date);
      return day.getDay() === 6 || day.getDay() === 0;
    }
  }
};
exports.default = _default;